import { MdEditor } from '@tap/mui-ui';
import Editor from 'react-markdown-editor-lite';

type CommentEditorProps = {
    message: string,
    setMessage: React.Dispatch<string>,
    editorRef: React.MutableRefObject<Editor | null>,
}

export const CommentEditor = ({ setMessage, message, editorRef }: CommentEditorProps) => {

    return (
        <MdEditor
            editorRef={editorRef}
            onChange={({ text }) => setMessage(text)}
            value={message}
        />
    )
}